import React from "react";
import Dropzone from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";

/**
 * FileUpload component using react-dropzone-uploader
 * @param {Object} props
 * @param {string|string[]} [props.accept] - Accepted file types (e.g. 'image/*' or ['image/png', 'application/pdf'])
 * @param {boolean} [props.multiple] - Allow multiple file selection
 * @param {function} [props.onChange] - Callback when files are selected/uploaded
 * @param {string} [props.inputContent] - Custom content for the drop area
 * @param {File[]} [props.initialFiles] - Files to seed the dropzone (e.g. from an API test)
 */
const FileUpload = ({
  accept,
  multiple = false,
  onChange,
  inputContent,
  initialFiles,
}) => {
  // react-dropzone-uploader expects accept as a comma-separated string
  const acceptString = Array.isArray(accept) ? accept.join(",") : accept;

  // Called every time files are selected or dropped
  const handleChangeStatus = (fileWithMeta, status, allFiles) => {
    if (onChange) {
      // Only pass files that are done uploading or added
      const files = allFiles.map(f => f.file);
      onChange(files);
    }
  };

  return (
    <Dropzone
      onChangeStatus={handleChangeStatus}
      accept={acceptString}
      multiple={multiple}
      initialFiles={initialFiles}
      inputContent={inputContent || "Drag & drop files here or click to browse"}
      styles={{
        dropzone: { minHeight: 180, borderRadius: 12, border: '2px dashed #6366f1', background: '#f8fafc', overflow: 'hidden' },
        inputLabel: { color: '#6366f1', fontWeight: 600, padding: '1rem' },
      }}
      canCancel={false}
      maxFiles={multiple ? undefined : 1}
    />
  );
};

export default FileUpload; 